define(['jquery', 'globalVars'], ($, { $body }) => {
    return (function () {
        const DURATION = 500;

        $body.on('click', '[data-scroll]', ev => {
            ev.preventDefault();

            const id = $(ev.currentTarget).attr('data-scroll');

            if (!id) {
                return;
            }

            const $headerContent = $('#stickyHeaderNav');
            const headerHeight = $headerContent.outerHeight();
            const top = $(id).offset().top - headerHeight;

            $('body, html').animate({ scrollTop: top }, DURATION);
        });
    })();
});
